import { HeartOutlined } from "@ant-design/icons";

const DoctorSheetHeader = () => {
  return (
    <h2 className="header-section-title">
      <HeartOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Scheda personale</span>
    </h2>
  );
};

export default DoctorSheetHeader;
